import {useAtomCallback} from 'jotai/utils';
import {memo, useEffect} from 'react';
import toast from '@/components/HotToast';
import {AnalysisItem, GeoDataItem} from '@/map/@types';
import {anaysisListAtom} from '@/map/atom';
import {MESSAGES, SHAPE_COLOR_OPTIONS} from '@/map/constants';
import {AreaOverlayType} from '@/map/enums';
import {getIntlString} from '@/utils';
import {EmdCursor} from '../MapCursor';

interface IProps {
  map: naver.maps.Map;
  isActiveZoomLevel?: boolean;
  onCancel?(): void;
  onComplete?(item: AnalysisItem[AreaOverlayType.EMD]): void;
}

export const SelectEmdLayer = memo(
  ({map, isActiveZoomLevel, onCancel, onComplete}: IProps) => {
    const handleComplete = useAtomCallback((get, _, emd: GeoDataItem) => {
      if (!isActiveZoomLevel) {
        return;
      }

      const list = get(anaysisListAtom);
      const index = list.findIndex(
        (i) =>
          i.type === AreaOverlayType.EMD &&
          i[AreaOverlayType.EMD]?.code === emd.code
      );

      if (index === -1) {
        onComplete?.(emd);
      } else {
        toast('이미 분석한 지역입니다.');
      }
    });

    useEffect(() => {
      if (!isActiveZoomLevel) {
        toast(
          getIntlString(MESSAGES, 'area-analytics-zoom-warning', {
            type: '단일 행정동 분석을',
          })
        );
      }
    }, [isActiveZoomLevel]);

    return (
      <>
        <EmdCursor
          map={map}
          colorOptions={SHAPE_COLOR_OPTIONS[AreaOverlayType.EMD]}
          displayNameTag
          onClick={handleComplete}
          onCancel={onCancel}
        />
      </>
    );
  }
);
